import { defineStore } from 'pinia'
import { computed, ref } from 'vue'
import http from '@/libs/http'
import dayjs from 'dayjs'
import { IUser } from './auth.store'

export const useUsersStore = defineStore('users', () => {
	// --- STATE ---
	const users = ref<IUser[]>([])
	const currentUser = ref<IUser | null>(null)
	const loading = ref<Record<string, boolean>>({})

	function formatError(error: any): string {
		return (
			error?.response?.data?.msg ||
			error?.response?.data ||
			error.message ||
			'An unexpected error occurred in module store'
		)
	}
	async function withLoading<T>(key: string, fn: () => Promise<T>): Promise<T> {
		if (loading.value[key]) {
			throw new Error(`${key} is already in progress (modul)`)
		}
		try {
			loading.value[key] = true
			return await fn()
		} finally {
			loading.value[key] = false
		}
	}

	const fetchUsers = async () => {
		return withLoading('fetchUsers', async () => {
			try {
				const resp:any = await http.getAuth<IUser[]>('/api/v1/users/list')
				users.value = resp.users || []
				return resp
			} catch (error: any) {
				throw new Error(formatError(error))
			}
		})
	}

	const updateAlertData = (data: any) => {
		return withLoading('updateAlertData', async () => {
			try {
				const resp = await http.putAuth<IUser>('/api/v1/users/alertdata', data)
				// Update the current user if it matches
				if (currentUser.value && currentUser.value.id === resp.id) {
					currentUser.value = resp
				}
				return resp
			} catch (error: any) {
				throw new Error(formatError(error))
			}
		})
	}

	const analyzeAlertData = async () => {
		return withLoading('analyzeAlertData', async () => {
			try {
				const resp = await http.getAuth<any>('/api/v1/admin/analyzeAlertData')
				console.log(resp)
				return resp
			} catch (error: any) {
				throw new Error(formatError(error))
			}
		})
	}
	const sendWarnAlertEmailTrigger = async () => {
		return withLoading('sendWarnAlertEmailTrigger', async () => {
			try {
				const resp = await http.getAuth<any>('/api/v1/admin/sendWarnAlertEmailTrigger')
				return resp
			} catch (error: any) {
				throw new Error(formatError(error))
			}
		})
	}

	return {
		// --- STATE ---
		users,
		currentUser,
		loading,

		// --- ACTIONS ---
		fetchUsers,
		updateAlertData,
		analyzeAlertData,
		sendWarnAlertEmailTrigger,
	}
})

// async _sendWarnAlertEmailTrigger({ dispatch }: any) {
// 	try {
// 		const config = await dispatch('_config')
// 		const resp = await axios.get(env.apiUrl + `/api/v1/admin/sendWarnAlertEmailTrigger`, config)
// 		return resp.data
// 	} catch (error: any) {
// 		throw new Error(await dispatch('_makeErrorMsg', error))
// 	}
// },

// async _analyzeAlertData({ dispatch }: any) {
// 	try {
// 		const config = await dispatch('_config')
// 		const resp = await axios.get(env.apiUrl + `/api/v1/admin/analyzeAlertData`, config)
// 		console.log(resp.data)
// 		return resp.data
// 	} catch (error: any) {
// 		throw new Error(await dispatch('_makeErrorMsg', error))
// 	}
// },

// async _fetchUsers({ commit, dispatch }: any) {
// 	console.log('_fetchUsers')
// 	try {
// 		const config = await dispatch('_config')
// 		const resp = await axios.get(env.apiUrl + '/api/v1/users/list', config)
// 		dispatch('_set', ['users', resp.data?.users])
// 		return resp.data?.users
// 	} catch (error: any) {
// 		if (error?.response?.data?.relogin) {
// 			commit('set', ['showLoginModal', true])
// 			return {}
// 		}
// 		throw new Error(error?.response?.data?.msg || error?.response?.data)
// 	}
// },

// async _updateAlertData({ state, dispatch }: any, data: any) {
// 	try {
// 		console.log('_updateAlertData', data)
// 		const config = await dispatch('_config')
// 		// const resp = await axios.post(env.apiUrl + '/api/v1/users/alertdata/update', data, config)
// 		const resp = await axios.put(env.apiUrl + '/api/v1/users/alertdata', data, config)
// 		return resp.data
// 	} catch (error: any) {
// 		throw new Error(error?.response?.data?.msg || error?.response?.data)
// 	}
// },
